import {onFind} from "@elements/init-modules-in-scope";
import { on, addClass, removeClass } from "@elements/dom-utils";

export function init() {
    let scrollDepth = 1000;

    onFind('.js-scroll-to-top', function (base) {
        addClass('d-none', base);
        window.addEventListener('scroll', function() {
            if (window.scrollY > scrollDepth) {
                removeClass('d-none', base);
            } else {
                addClass('d-none', base);
            }
        });

        on('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            return false;
        }, base);
    });
}